var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueeye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.54626 8.7379C1.48377 8.90627 1.48377 9.09147 1.54626 9.25983C2.15496 10.7358 3.18819 11.9977 4.51496 12.8857C5.84173 13.7737 7.4023 14.2477 8.99881 14.2477C10.5953 14.2477 12.1559 13.7737 13.4827 12.8857C14.8094 11.9977 15.8427 10.7358 16.4514 9.25983C16.5139 9.09147 16.5139 8.90627 16.4514 8.7379C15.8427 7.26198 14.8094 6.00003 13.4827 5.11204C12.1559 4.22405 10.5953 3.75 8.99881 3.75C7.4023 3.75 5.84173 4.22405 4.51496 5.11204C3.18819 6.00003 2.15496 7.26198 1.54626 8.7379Z",
    stroke: "#155DFC",
    strokeWidth: 1.49981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99886 11.2484C10.2413 11.2484 11.2486 10.2412 11.2486 8.99874C11.2486 7.75625 10.2413 6.74902 8.99886 6.74902C7.75638 6.74902 6.74915 7.75625 6.74915 8.99874C6.74915 10.2412 7.75638 11.2484 8.99886 11.2484Z",
    stroke: "#155DFC",
    strokeWidth: 1.49981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueeye);
export default __webpack_public_path__ + "static/media/blueeye.b4729523e8e521de7d942e92ad95ab56.svg";
export { ForwardRef as ReactComponent };